<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header">{{ t.sessions }}
          <a href="javascript:void(0);">( Export to excel )</a>
        </div>
        <div class="card-block p-0">
          <div class="table-responsive">
            <div class="bootstrap-table">
              <div class="fixed-table-toolbar"></div>
              <div class="fixed-table-container" style="padding-bottom: 0px;">
                <div class="fixed-table-body">
                  <table id="table" data-toggle="table" class="table table-hover">
                    <thead v-if="$root.windowWidth >= 600">
                    <tr>
                      <th style="" data-field="id" tabindex="0">
                        <div class="th-inner ">id</div>
                        <div class="fht-cell"></div>
                      </th>
                      <th style="" data-field="username" tabindex="0">
                        <div class="th-inner ">{{ t.username }}</div>
                        <div class="fht-cell"></div>
                      </th>
                      <th style="" data-field="ip" tabindex="0">
                        <div class="th-inner ">IP</div>
                        <div class="fht-cell"></div>
                      </th>
                      <th style="" data-field="agent" tabindex="0">
                        <div class="th-inner ">Agent</div>
                        <div class="fht-cell"></div>
                      </th>
                      <th style="" data-field="startDate" tabindex="0">
                        <div class="th-inner ">{{ t.start_date }}</div>
                        <div class="fht-cell"></div>
                      </th>
                      <th style="" data-field="endDate" tabindex="0">
                        <div class="th-inner ">{{ t.end_date }}</div>
                        <div class="fht-cell"></div>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="no-records-found" v-if="loading">
                      <td colspan="6" align="center">
                        <Loading></Loading>
                      </td>
                    </tr>
                    <template v-if="!loading">
                      <tr class="no-records-found" v-if="sessions.length < 1">
                        <td colspan="6">{{ t.error.notfound_content_list }}</td>
                      </tr>
                      <template v-else-if="$root.windowWidth < 600">
                        <tr v-for="(user_session, idx) in sessions" :key="idx">
                          <td colspan="5">
                            <div class="card-views">
                              <div class="card-view">
                                <span class="title">id</span>
                                <span class="value">{{ user_session.id }}</span>
                              </div>
                              <div class="card-view">
                                <span class="title">{{ t.user.username }}</span>
                                <span>{{ user_session.user.username }}</span>
                              </div>
                              <div class="card-view">
                                <span class="title">IP</span> <!-- tr -->
                                <span class="value">{{ user_session.ip }}</span>
                              </div>
                              <div class="card-view">
                                <span class="title">Agent</span>
                                <span class="value">{{ user_session.agent }}</span>
                              </div>
                              <div class="card-view">
                                <span class="title">{{ t.start_date }}</span> <!-- tr -->
                                <span class="value">{{ dateTimeFormat(user_session.createdAt) }}</span>
                              </div>
                              <div class="card-view">
                                <span class="title">{{ t.end_date }}</span> <!-- tr -->
                                <span class="value">{{ dateTimeFormat(user_session.endedAt) }}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(user_session, idx) in sessions" :key="idx">
                          <td>{{ user_session.id }}</td>
                          <td>
                            <span>{{ user_session.user.username }}</span>
                          </td>
                          <td>
                            <span>{{ user_session.ip }}</span>
                          </td>
                          <td>
                            <span>{{ user_session.agent }}</span>
                          </td>
                          <td>
                            <span>{{ dateTimeFormat(user_session.createdAt) }}</span>
                          </td>
                          <td>
                            <span>
                              {{ dateTimeFormat(user_session.endedAt) }}
                            </span>
                          </td>
                        </tr>
                      </template>
                    </template>
                    </tbody>
                  </table>
                </div>
                <div class="fixed-table-footer">
                  <paginate v-if="pagination" class="mx-3"
                            :page-count="pagination.pageCount"
                            :page-range="pagination.pageRange"
                            :force-page="(pagination.current)"
                            :initialPage="(pagination.current)"
                            :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                            :click-handler="onChangePage"
                            :prev-text="t.previous"
                            :next-text="t.next"
                            :container-class="'my-1 pagination float-right mr-0 ml-1'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-item'"
                            :prev-link-class="'page-link'"
                            :next-class="'page-item'"
                            :next-link-class="'page-link'"
                  >
                  </paginate>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
import Paginate from "vuejs-paginate";
export default {
  name: "Sessions",
  components: {Loading, Paginate},
  data() {
    return {
      sessions: [],
      session: session,
      pagination: null,
      t: this.$root.t,
      loading: false
    }
  },
  mounted() {
    this.fetchSessions();
  },
  methods: {
    fetchSessions() {
      this.loading = true;
      this.$http.get(api + 'api/v1/sessions', {
        params: {
          type: [0],
          page: this.$route.query.page,
          per_page: 10,
          direction: 'desc',
          sort: 's.id'
        }
      })
          .then(response => {
            this.sessions = response.body.result.sessions;
            this.pagination = response.body.result.pagination;
            this.loading = false;
            this.notfound = false;
          }, response => {
            this.sessions = [];
            this.loading = false;
            this.notfound = true;
          })
    },
    onChangePage (page) {
      this.pagination.current = page;
      this.$router.push({ query: {page: page} });
      window.scroll(0, 0);
      this.fetchSessions()
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Sessions.vue